import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanLoad,
    Route,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import {CurrentUser} from '@common/auth/current-user';
import {ONBOARDING_LOCAL_STORAGE_KEY} from '@common/billing/upgrade-page/upgrade-page.component';
import {LocalStorage} from '@common/core/services/local-storage.service';
import { WorkspacesService } from '@common/workspaces/workspaces.service';

@Injectable({
    providedIn: 'root',
})
export class RedirectToOnboardingGuard
    implements CanActivate, CanActivateChild, CanLoad
{
    constructor(
        private currentUser: CurrentUser,
        private router: Router,
        private workspaces: WorkspacesService,
        private localStorage: LocalStorage
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.handle();
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        return this.handle();
    }

    canLoad(route: Route) {
        return this.handle();
    }

    private handle() {
        if (
            this.currentUser.isLoggedIn() &&
            !this.currentUser.isSubscribed() &&
            !this.workspaces.activeId$.value &&
            this.localStorage.get(ONBOARDING_LOCAL_STORAGE_KEY)
        ) {
            // only redirect to onboarding page once, after initial registration
            this.localStorage.remove(ONBOARDING_LOCAL_STORAGE_KEY);
            this.router.navigate(['/billing/upgrade']);
            return false;
        }

        return true;
    }
}
